import React,{useState, useContext} from 'react'
// import { Link } from 'react-router-dom'
import logo from '../img/a-letter-logo-png-19.png'
import "headroom.js";
import Headroom from 'react-headroom';
import {SlBag} from 'react-icons/sl';
import {FiMenu} from 'react-icons/fi';
import { FiSearch } from 'react-icons/fi';
import CategoryNavMobile from './CategoryNavMobile';
import { CartContext } from '../context/CartContext';

import Cart from './Cart';
function Header() {
  const [catNavMobile, setCatnavMobile]= useState(false);
  const{isOpen,setIsOpen,itemsAmount,item} =useContext(CartContext)
  return (
    //desktop
    < div className=' bg-white'>
        <Headroom className='z-50 relative bg-white'>
      <header className='py-5 con flex justify-between z-50 bg-white'>
        <div className=' z-50 flex justify-between align-items-center'>
          {/* <Link to={'home'}> */}
            <img  src={logo} className='w-10 md:block hidden cursor-pointer' alt=''></img>
        {/* </Link> */}
        <div onClick={()=>setCatnavMobile(true)} className='text-3xl md:hidden cursor-pointer'>
        <FiMenu/>
      </div>
      
      <div 
      className={`${
        catNavMobile? 'left-0' : '-left-full'
        } fixed top-0 bottom-0 z-30 w-full h-screen transition-all duration-200`}>
        <CategoryNavMobile setcatNavMobile={setCatnavMobile}/>
      </div>
      
          <ul className=' md:inline-flex flex-nowrap ml-5 cursor-pointer hidden'>
          <li><a className=' text-decoration-none text-gray-500 p-5 text-[15px] hover:text-gray-800 hover:underline duration-300 transition-all'>Home</a></li>
          <li><a className=' text-decoration-none text-gray-500 p-5 text-[15px] hover:text-gray-800 hover:underline duration-300 transition-all'>Catalog</a></li>
          <li><a className=' text-decoration-none text-gray-500 p-5 text-[15px] hover:text-gray-800 hover:underline duration-300 transition-all'>Contact</a></li>
          </ul>
          </div>
          <img  src={logo} className='w-10 md:hidden text-center cursor-pointer' alt=''></img>
          <div className=' flex'>
            <FiSearch  className=' mr-4 cursor-pointer'/>
            <div onClick={()=>setIsOpen(!isOpen)} className=' relative cursor-pointer'>
          <SlBag className=' text-2xl'/>
        <div className='bg-accent text-primary absolute w-[18px] rounded-full top-3 right-1 text-[13px]
          flex justify-center items-center font-bold tracking-[-0.1em]'>{item}</div>
        </div>
        </div>
    </header>
        </Headroom>
        <div className={`
        ${isOpen? 'right-0': '-right-full'}
        bg-[#0e0f10] shadow-xl fixed top-0 bottom-0 w-full md:max-w-[500px]
          translate-all duration-300 z-[200]`}>
          <Cart/>
        </div>
          
    </div>

    
    
  )
}

export default Header